import React, { useEffect, useState } from "react";
import DatePicker, { Day, DayRange, DayValue } from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "moment";
import ReactDatePicker from "react-datepicker";

interface DateFormFlushProps {
    placeholder: string;
    value: string | null;
    setValue: (isoString: string) => void;
}

export const DateFormFlush: React.FC<DateFormFlushProps> = ({
    placeholder,
    value,
    setValue,
}) => {
    const [selectedDay, setSelectedDay] = useState(
        value ? moment(value).format("DD-MM-YYYY").toString() : moment(new Date()).format("DD-MM-YYYY").toString()
    );


    const handleChange = (e: any) => {
        setSelectedDay(moment(e).format("DD-MM-YYYY").toString());
        if (e) {
            setValue(moment(e).format().toString());
        }
    };

    return (
        <div style={{ position: "relative", width: "100%" }}>
            <ReactDatePicker
                onChange={(e: any) => {
                    handleChange(e);
                }}
                value={selectedDay}
                selectsRange={false}
                dateFormat="dd/MM/yyyy"
                className="form-control"
            />
        </div>
    );
};


interface DateFormRangeFlushProps {
    placeholder: string;
    value: { from: string | null; to: string | null };
    setValue: (range: { from: string; to: string }) => void;
}

export const DateFormRangeFlush: React.FC<DateFormRangeFlushProps> = ({
    placeholder,
    value,
    setValue,
}) => {
    const [dateRange, setDateRange] = useState({
        startDate: value.from ? moment(value.from).toDate() : moment(new Date()).subtract("10", "days").toDate(),
        endDate: value.to ? moment(value.to).toDate() : moment(new Date()).add("30", "days").toDate(),
      });

    const handleChange = (e:any)=>{
        setDateRange({
            startDate: e[0],
            endDate: e[1],
        });

        if(e[0] &&  e[1]){
            setValue({
                from: moment(e[0]).format(),
                to: moment(e[1]).format(),
            });
        }
    }


    return (
        <div style={{ position: "relative", width: "100%" }}>
            <ReactDatePicker
                onChange={(e: any) => {
                    handleChange(e);
                }}
                placeholderText="Select Date"
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                selectsRange={true}
                dateFormat="dd/MM/yyyy"
                className="form-control"
            />
        </div>
    );
};
